export default __webpack_public_path__ + "static/media/Shevatas Jewel-Hiked Blade.85d33fd9.jpg";